import React from "react";
import { FiUpload } from "react-icons/fi";
import { MdAttachFile } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import {
  getPolicyDocumentName,
  getPolicyDocumentSizeLabel,
} from "./hsePolicyUtils";

function HsePolicyFormFields({
  formData,
  errors,
  onInputChange,
  fileInputRef,
  documents,
  isDocumentPopupOpen,
  onUploadClick,
  onFileInputChange,
  onToggleDocumentPopup,
  onCloseDocumentPopup,
  onDeleteDocument,
}) {
  return (
    <div className="new-data-form">
      <div className="form-group">
        <label htmlFor="title">
          Title <span className="text-danger">*</span>
        </label>
        <div className="input-group">
          <input
            id="title"
            name="title"
            type="text"
            value={formData.title}
            onChange={onInputChange}
            placeholder="Enter policy title"
          />
        </div>
        {errors.title && <div className="error-message">{errors.title}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="category">Category</label>
        <div className="input-group">
          <input
            id="category"
            name="category"
            type="text"
            value={formData.category}
            onChange={onInputChange}
            placeholder="Enter policy category"
          />
        </div>
        {errors.category && (
          <div className="error-message">{errors.category}</div>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="effective_date">Effective Date</label>
        <div className="input-group">
          <input
            id="effective_date"
            name="effective_date"
            type="date"
            value={formData.effective_date}
            onChange={onInputChange}
          />
        </div>
        {errors.effective_date && (
          <div className="error-message">{errors.effective_date}</div>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="description">Description</label>
        <div className="input-group">
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={onInputChange}
            placeholder="Enter policy description"
            rows={5}
          />
        </div>
        {errors.description && (
          <div className="error-message">{errors.description}</div>
        )}
      </div>

      <div className="form-group-attachments">
        <div className="form-group">
          <label htmlFor="policy_documents">Documents</label>
          <button
            type="button"
            className="challan-btn"
            onClick={onUploadClick}
          >
            <FiUpload /> Upload File
          </button>
          <input
            type="file"
            id="policy_documents"
            ref={fileInputRef}
            onChange={onFileInputChange}
            style={{ display: "none" }}
            multiple
          />
          {documents.length > 0 && (
            <span
              className="inquiry-file-btn"
              onClick={onToggleDocumentPopup}
              style={{height:"39px"}}
            >
              <MdAttachFile className="inquiry-file-icon" /> {documents.length}
            </span>
          )}
          {isDocumentPopupOpen && (
            <div className="attach-popup-amc1">
              <div className="attach-popup-contant">
                <div className="attachment-header">
                  <div className="attachment-header-content">Documents</div>
                  <button
                    type="button"
                    className="fiile-close-btn"
                    onClick={onCloseDocumentPopup}
                  >
                    <IoCloseOutline className="file-close-icon" />
                  </button>
                </div>
                {documents.length > 0 ? (
                  <div className="attach-scrroll-body">
                    {documents.map((document, index) => (
                      <div className="attach-popup-contant-body" key={index}>
                        <div className="attach-file-container">
                          <div className="attach-file-show">
                            <div className="text-attachment">
                              {getPolicyDocumentName(document)}
                            </div>
                            <div className="text-attachment-file">
                              File Size: ({getPolicyDocumentSizeLabel(document)})
                            </div>
                          </div>
                          <div
                            className="file-delete-btn"
                            onClick={() => onDeleteDocument(index)}
                          >
                            <span>
                              <IoCloseOutline className="file-close-icon" />
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="meeting-no-attachments">
                    No documents selected
                  </div>
                )}
              </div>
            </div>
          )}
          {errors.documents && (
            <div className="error-message">{errors.documents}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HsePolicyFormFields;
